import { createSelector } from 'reselect';

import { getBalanceSellingAccountsMap } from './Data/Data.selector';
import { USD } from '../../libs/formatter';

const getAmazonAccounts = state => state.dynamicData.amazonAccounts;
const getAmazonBalances = state => state.dynamicData.amazonBalances;
const getRankedAccounts = state => state.dynamicData.rankedAccounts;

export const getRankedAccountsWithRank = createSelector(
  [getRankedAccounts, getBalanceSellingAccountsMap],
  (accounts, balanceAccountsMap) => {
    if (!accounts) {
      return [];
    }
    return accounts.map((account, i) => {
      const balanceString = account.timestamp ? `$${account.balance}` : 'N/A';
      const dateString = account.timestamp ? ((new Date(account.timestamp)).toLocaleString()) : 'N/A';
      const balanceAccount = balanceAccountsMap[account.value];
      let balanceMatches = false;
      let sellBalance;
      if (balanceAccount) {
        sellBalance = balanceAccount && ((balanceAccount.gift_balance || 0) / 100);
        balanceMatches = Math.ceil(sellBalance) === Math.ceil(account.balance)
      }
      return {
        ...account,
        rank: i + 1,
        originalLabel: account.label,
        balanceString,
        dateString,
        label: `${account.label} - ${account.value} - $${account.redeemedDay} (day) / ${balanceString} (${dateString})`,
        sellBalance,
        balanceMatches,
        primeExternal: balanceAccount ? balanceAccount.prime : undefined,
        balanceAccount,
      };
    });
  },
);

export const getRankedAccountsSliced = createSelector(
  [getRankedAccountsWithRank],
  accounts => accounts
    .filter(account => !account.isDeleted && !account.deactivated && !account.autoDisabled)
    .slice(0, 20),
);

export const getAmazonAccountsWithBalances = createSelector(
  [getAmazonAccounts, getAmazonBalances],
  (accounts, balances) => {
    if (!accounts) {
      return [];
    }
    const balanceMap = {};
    balances && balances.forEach(balance => {
      // keep name for old data and backwards compatibility
      balanceMap[balance.username || balance.name] = balance;
    });
    return accounts
      .filter(account => !account.isDeleted)
      .map((account) => {
        // keep accountName for old data and backwards compatibility
        const balance = balanceMap[account.value] || balanceMap[account.accountName];
        let label = account.label;
        if (balance) {
          label = `${label} - $${balance.balance} (${(new Date(balance.timestamp)).toLocaleString()})`
        }
        return {
          ...account,
          balance,
          label,
        };
      });
  },
);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/WorkArea.selectors.js